<template>
  <div class="importResult">
    <!-- 搜索表单 -->
    <!-- <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="140px" inline label-position='top'>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="searchForm.remarks"
            v-trim
            placeholder="请输入备注"
            @keypress.enter.native="search"
            maxlength="100"
          />
        </el-form-item>
        <section>
          <div class="btnBox">
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </div>
        </section>
      </el-form>
    </SearchFormCollapse> -->

    <PublicTable
      ref="dialogTable"
      :data-source="dataSource"
      @sizeChange="changeSize"
      @currentChange="changeNum"
      @handleSelection="publicTableHandleSelectionChange"
    > 
    </PublicTable>
  </div>
</template>
<script>
import { importResultPageApi } from "@/api/consolidate_returned_materials";
import cols from "./importResultModel";
import SearchFormCollapse from "@/components/common/SearchFormCollapse";
export default {
  components: {
    SearchFormCollapse,
  },
  props:{
    ImportResultData:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      // 搜索
      searchForm: {
        remarks: "",
      },
      dataSource: {
        topButtons: [
          //  {
          //    name: '添加群组项', //按钮名称
          //    key: 1,  // 唯一标识符
          //   //  permission: 2010106, // 权限点
          //   //  type: '',  // 使用element自带按钮类型
          //    bgColor: 'skyblue', // 自定义背景色
          //    handleClick: this.handleEdit, //自定义事件
          //    disabled:false,//是否禁用
          //    loading:false,//是否加载中状态
          //  },
        ],
        data: [], // 表格数据
        cols, // 表格的列数据
        publicTableHandleSelectionChange: (val) => {}, // 点击行选中多选返回选中数组
        isSelection: false, // 表格有多选时设置
        isMultipleChoice: false, // 是否单选
        isReserve: false, // 是否分页多选
        isOperation: false, // 表格有操作列时设置
        isIndex: false, // 列表序号
        loading: false, // loading
        pageData: {
          total: 0, // 总条数
          pageSize: 10, // 每页数量
          pageNum: 1, // 页码
          pageSizes: [10, 20, 30, 40], // 每页数量
        },
        operation: {
          // 表格有操作列时设置
          label: "操作", // 列名
          width: "150", // 根据实际情况给宽度
          data: [
            // {
            //   label: "冻结", // 操作名称
            //   // permission:'', //权限点
            //   type: "info", //按钮类型
            //   handleRow: function () {}, // 自定义事件
            // },
          ],
        },
      },
      pageReqParams: {
        page: 1,
        capacity: 10,
        model: {},
        sorts: null,
      },
    };
  },
  methods: {
    search() {
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    reset() {
      for (let key in this.searchForm) {
        this.searchForm[key] = "";
      }
      this.pageReqParams.model = this.searchForm;
      this.newPage();
    },
    // 详情表格选中数据
    publicTableHandleSelectionChange(val) {
      this.checkedSelectArr = val;
    },
    // 改变每页查询数量
    changeSize(size) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = 1;
      this.pageReqParams.capacity = this.dataSource.pageData.pageSize = size;
      this.newPage();
    },
    // 分页页码
    changeNum(pageNum) {
      this.pageReqParams.page = this.dataSource.pageData.pageNum = pageNum;
      this.newPage();
    },
    // 请求dialog列表项
    newPage() {
      this.dataSource.loading = true;
      importResultPageApi(this.pageReqParams).then((res) => {
        this.dataSource.data = res.records || [];
        this.dataSource.pageData.total = res.total;
        this.dataSource.loading = false;
      });
    },
  },
  created() {
    this.dataSource.data=this.ImportResultData;
    // this.newPage();
  },
};
</script>
<style lang="scss" scoped>
.btnBox {
  line-height: 114px;
}
.box {
  position: absolute;
  left: 10px;
  bottom: 20px;
}
</style>
